import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class ZonasService extends CrudService<any> {

  constructor(private config: AppConfigService, http: HttpClient) {
    super(config.ZonasUrl, http);
  }
  getZonaCP(placeId: string) {
    let url = `${this.endpoint}/GetZonaCP?placeId=${placeId}`
    return this.http.get<any>(url);
  }
  getZonaByCP_public(placeId: string) {
    let url = `${this.config.VentaRapidaUrl}/zonas/bycp?placeId=${placeId}`
    return this.http.get<any>(url);
  }
}
